import React from 'react'
import { Outlet } from 'react-router-dom'
import { MaxWidthWrapper } from '@/components'

const AuthLayout = () => {
  return (
    <MaxWidthWrapper>
      <main className="mx-auto w-full relative">
        <Outlet />
      </main>
    </MaxWidthWrapper>
  )
}

export default AuthLayout
